import { Component, ViewChild,Input, OnInit } from '@angular/core';
/*Plugins */
import { BsModalComponent } from 'ng2-bs3-modal';

/*Services*/
import { ShareDeviceService } from "@services"

import { Device } from '@models';



declare var swal: any;

@Component({
  selector: 'app-share-device-modal',
  templateUrl: './share-device-modal.component.html'
})

export class ShareDeviceModalComponent implements OnInit {

  @ViewChild('shareDeviceModal') shareDeviceModal: BsModalComponent;
  currentDevice: Device;
  
  phoneModel: string;
  errorMessage: string;
 
  deviceId: string;
  ifShowPopup = false;
  accessList = [
    {
      name:"Стандартный доступ",
      id: "baseAccess"
    },
    {
      name:"Полный доступ",
      id: "fullAccess"
    }
    
  ]
  accessModel = this.accessList[0].id;
  btnText: any = {
    text: 'Отправить',
    defaultText: 'Отправить',
    loadText: 'Отправление..'
  };

  trySubmit = false;


  constructor(private shareDeviceService: ShareDeviceService){}


  ngOnInit(){
    this.initForm()
  }
  open(device: Device) {
      this.initForm()
      console.log(this.phoneModel)
      this.currentDevice = device;
      this.ifShowPopup  = true;
      this.shareDeviceModal.open();
  }
  initForm(){
    this.accessModel = this.accessList[0].id;
    this.phoneModel = null;
    this.ifShowPopup  = false;
    this.errorMessage = null;
  }
  close() {
    this.shareDeviceModal.close();
   
  }

  submit(){
    this.trySubmit = true;
    if(!this.phoneModel){
        return;
    }
    this.errorMessage = null;
    this.btnText.text = this.btnText.loadText;
    this.shareDeviceService.shareDevice(this.phoneModel.replace(/\D/g, ''),this.currentDevice.id,this.accessModel)
      .subscribe(response => {
        this.trySubmit  = false;
        this.btnText.text = this.btnText.defaultText;

        this.shareDeviceService.updateRequestsSubject.next(null)
          swal({
            type: 'success',
            text: 'Доступ отправлен',
            showConfirmButton: false,
            timer: 3000,
          });
        
        this.close();
      },
        error => {
          
          console.log(error)
          let errorMessage = 'Ошибка, проверьте корректность данных или повторите позже';
          if (error.error && error.error.errorMessage) {
            errorMessage = error.error.errorMessage;
          }
  
          this.errorMessage = errorMessage;
          this.trySubmit = false;
          this.btnText.text = this.btnText.defaultText;
          console.log(error.type);
        }
      );

  }

  onChangePhone(value) {
      this.trySubmit = false;
      this.phoneModel = value;
    //this.addObjectForm.controls['phonenumber'].setValue(value);
  }

}



// WEBPACK FOOTER //
// ./src/app/view/modal/share-device-modal/share-device-modal.component.ts